// extracted by mini-css-extract-plugin
module.exports = {"stepperCompleted":"#95bc51","stepperActive":"#364248","stepperTextColor":"#fff"};